import './App.css';
import Home from './components/Home';
import "./index.css"


function App() {
  return (
    <div className="App">    
      <Home/>
    </div>
  );
}

export default App;
